import { defineComponent, computed, ref, onMounted, nextTick, onUnmounted, watch } from "vue";
import throttle from "./component-library154.mjs";
import { directive as directive_1 } from "./component-library284.mjs";
import LinkButton from "./component-library3.mjs";
import useDropdown from "./component-library91.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "tooltip",
  props: {
    text: { default: void 0 },
    position: { default: "auto" },
    button: { default: void 0 },
    openOnHover: { type: Boolean, default: false },
    openOnClick: { type: Boolean, default: true },
    opened: { type: Boolean, default: false },
    innerAriaHidden: { type: Boolean, default: false },
    mobileFirstTapTooltip: { type: Boolean, default: true }
  },
  emits: ["click"],
  setup(__props, { expose, emit }) {
    const props = __props;
    const openable = useDropdown();
    const containerClass = computed(() => ({
      tooltip: true,
      "tooltip--open": openable.isOpened.value,
      "tooltip--open-on-hover": props.openOnHover
    }));
    const buttonElement = ref(null);
    const tooltipElement = ref(null);
    const calculatedPosition = ref("top");
    const tooltipPosition = computed(
      () => props.position !== void 0 && props.position !== "auto" ? props.position : calculatedPosition.value
    );
    const resizeHandler = () => {
      var _a;
      if (props.position !== void 0 && props.position !== "auto")
        return;
      if (!tooltipElement.value || !((_a = buttonElement.value) == null ? void 0 : _a.$el))
        return;
      const tooltipBounds = tooltipElement.value.getBoundingClientRect();
      const buttonBounds = buttonElement.value.$el.getBoundingClientRect();
      const windowWidth = window.document.body.offsetWidth;
      const windowHeight = window.document.body.offsetHeight;
      const spaceTop = buttonBounds.top;
      const spaceRight = windowWidth - buttonBounds.right;
      const spaceBottom = windowHeight - buttonBounds.bottom;
      const spaceLeft = buttonBounds.left;
      const positions = [
        { position: "top", space: spaceTop - tooltipBounds.height },
        { position: "bottom", space: spaceBottom - tooltipBounds.height },
        { position: "left", space: spaceLeft - tooltipBounds.width },
        { position: "right", space: spaceRight - tooltipBounds.width }
      ];
      const validPositions = positions.filter((pos) => pos.space >= 0);
      let preferredPosition = validPositions.length > 0 ? validPositions.reduce((max, pos) => pos.space > max.space ? pos : max).position : "top";
      if (validPositions.length === 0) {
        if (spaceBottom >= tooltipBounds.height) {
          preferredPosition = "bottom";
        } else if (spaceTop >= tooltipBounds.height) {
          preferredPosition = "top";
        } else if (spaceRight >= tooltipBounds.width) {
          preferredPosition = "right";
        } else if (spaceLeft >= tooltipBounds.width) {
          preferredPosition = "left";
        }
      }
      calculatedPosition.value = preferredPosition;
    };
    const throttledResizeHandler = throttle(resizeHandler, 250);
    const isOpendOnClick = ref(false);
    const mobileTooltipShown = ref(false);
    onMounted(() => {
      if (props.opened) {
        openable.isOpened.value = true;
      }
      nextTick(() => {
        resizeHandler();
      });
    });
    onUnmounted(() => {
      window.removeEventListener("resize", throttledResizeHandler);
    });
    watch(openable.isOpened, (val) => {
      if (!val) {
        window.removeEventListener("resize", throttledResizeHandler);
        mobileTooltipShown.value = false;
        return;
      }
      window.addEventListener("resize", throttledResizeHandler);
      nextTick(() => {
        resizeHandler();
      });
    });
    const click = (event) => {
      if (props.openOnHover) {
        if (props.mobileFirstTapTooltip && event.pointerType === "touch") {
          if (!openable.isOpened.value || !mobileTooltipShown.value) {
            event.preventDefault();
            event.stopPropagation();
            openable.open();
            mobileTooltipShown.value = true;
            return;
          }
          emit("click", event);
          mobileTooltipShown.value = false;
          openable.close();
        } else if (event.pointerType !== "touch") {
          emit("click", event);
        }
        return;
      }
      if (props.openOnClick) {
        emit("click", event);
        if (!isOpendOnClick.value) {
          openable.open();
          isOpendOnClick.value = true;
        } else {
          openable.close();
          isOpendOnClick.value = false;
        }
      }
    };
    const mouseOver = () => {
      if (props.openOnHover) {
        openable.open();
      }
    };
    const mouseLeave = () => {
      if (props.openOnHover && !isOpendOnClick.value) {
        openable.close();
      }
      mobileTooltipShown.value = false;
    };
    const onFocus = () => {
      if (props.openOnHover) {
        openable.open();
      }
    };
    const onBlur = () => {
      if (props.openOnHover && !isOpendOnClick.value) {
        openable.close();
      }
    };
    expose({ resizeHandler });
    return { __sfc: true, openable, emit, props, containerClass, buttonElement, tooltipElement, calculatedPosition, tooltipPosition, resizeHandler, throttledResizeHandler, isOpendOnClick, mobileTooltipShown, click, mouseOver, mouseLeave, onFocus, onBlur, vOnClickaway: directive_1, LinkButton };
  }
});
export {
  _sfc_main as default
};
